export const getProviderDocumentationMarkdown = `
# Get Provider

Retrieve the User record with Role Provider from the Notable database.

By default, the Provider User ID Encounter from the Start Block is used.

A Provider ID can be specified to get a specific provider. If a Provider ID is given, then the type of Provider ID (User ID or Ehr Provider Information ID) must be provided as well.
`;
